module.exports = _.invoke;